import api from '../api'

export const emailVerificationService = {
  async verifyEmail(token: string) {
    const response = await api.post('/verify-email', { token })
    return response.data
  }
}
